<template>
  <div id="app" @click='resetTimer()'>
    <flash></flash>
    <router-view />
  </div>
</template>

<script>
import Header from './components/Header.vue';
const fb = require("./firebaseConfig.js");
const db = fb.default.db;
  
export default {
  name: "App",
  data() {
  	return {
		timeout: 0,
		activations: null
  	}
  },
  components: {
	'flash': Header
  },
  created(){
	let vm = this;
    db.collection("activation")
    .orderBy('created', 'desc')
    .onSnapshot(function(doc) {
        vm.activations = doc.docs.map((obj) => {
			let data = obj.data();
			data.id = obj.id;
			return data;
		});
    });
  },
  mounted(){
  	this.startTimer();
  },
  methods: {
  	resetTimer() {
	  let vm = this;
	  window.clearTimeout(vm.timeout);
	  this.startTimer();
	},
	startTimer(){
	  clearTimeout(this.timeout);
	  this.timeout = 0;
	  let vm = this;
	  this.timeout = window.setTimeout(
	      function() {
	          setTimeout(function(){
	              if (vm.$route.name != 'home') {
					  if (!vm.activations[0].complete) {
						  vm.resetHome();
					  }
	              }else {
					  if (vm.activations[0].complete ){
						  window.location.reload();
					  }
	              }
	      }, 500);
	  }, 600000);
	},
	resetHome(){
		this.activations[0].complete = true;
		db.collection('activation').doc(this.activations[0].id)
        .set(this.activations[0], {merge: true})
        .then(()=>{
			window.location.reload();
        })
        .catch((err)=>{
			window.location.reload();
        });
	}
  }
};
</script>


<style src='../public/css/main.css'></style>

